import { OneDecimalPlace } from '../../../helpers/Helpers';

export const totalWeeksOfSelectedQuarter = (colArr, quarterIdx: number): number => {
  return colArr[quarterIdx].months.reduce((acc, month) => {
    acc += month.weeks.length;
    return acc;
  }, 0) + 1;
};

export const calculateMeasureTotal = (rowArr, rIdx: number, mIdx: number, measureGroup: string, measureName: string): number => {
  /*UNITS*/
  if (measureName === 'Fcst Unconst vs LY U') {
    const forecastUnconstrainedIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Forecast Unconstrained U');
    const lyActualsIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'LY - Actuals U');

    if (forecastUnconstrainedIdx === -1 || lyActualsIdx === -1) {
      return 0;
    }

    const forecastUnconstrained = calculateActualMeasureTotal(rowArr[rIdx].measures[forecastUnconstrainedIdx].quarters, true);
    const lyActuals = calculateActualMeasureTotal(rowArr[rIdx].measures[lyActualsIdx].quarters, true);

    return Math.round(forecastUnconstrained - lyActuals);
  }

  if (measureName === 'Plan vs Fcst Uncons U') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota U');
    const forecastUnconstrainedIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Forecast Unconstrained U');

    if (planQuotaIdx === -1 || forecastUnconstrainedIdx === -1) {
      return 0;
    }

    const planQuota = calculateActualMeasureTotal(rowArr[rIdx].measures[planQuotaIdx].quarters, true);
    const forecastUnconstrained = calculateActualMeasureTotal(rowArr[rIdx].measures[forecastUnconstrainedIdx].quarters, true);

    return Math.round(planQuota - forecastUnconstrained);
  }

  if (measureName === 'PL vs LY U %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota U');
    const lyActualsIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'LY - Actuals U');

    if (planQuotaIdx === -1 || lyActualsIdx === -1) {
      return 0;
    }

    const planQuota = calculateActualMeasureTotal(rowArr[rIdx].measures[planQuotaIdx].quarters, true);
    const lyActuals = calculateActualMeasureTotal(rowArr[rIdx].measures[lyActualsIdx].quarters, true);

    return lyActuals !== 0 ? OneDecimalPlace(((planQuota - lyActuals) / lyActuals) * 100) : 0;
  }

  if (measureName === 'PL vs LQ U %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota U');
    const lqActualsIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'LQ - Actuals U');

    if (planQuotaIdx === -1 || lqActualsIdx === -1) {
      return 0;
    }

    const planQuota = calculateActualMeasureTotal(rowArr[rIdx].measures[planQuotaIdx].quarters, true);
    const lqActuals = calculateActualMeasureTotal(rowArr[rIdx].measures[lqActualsIdx].quarters, true);

    return lqActuals !== 0 ? OneDecimalPlace(((planQuota - lqActuals) / lqActuals) * 100) : 0;
  }

  if (measureName === 'PL vs AC U') {
    const actualSalesIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Actual Sales U');
    const rollingPlanQuotaFrozenIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Rolling Plan / Quota Frozen U');

    if (actualSalesIdx === -1 || rollingPlanQuotaFrozenIdx === -1) {
      return 0;
    }

    const actualSales = calculateActualMeasureTotal(rowArr[rIdx].measures[actualSalesIdx].quarters, true);
    const rollingPlanQuotaFrozen =
      calculateActualMeasureTotal(rowArr[rIdx].measures[rollingPlanQuotaFrozenIdx].quarters, true);

    return Math.round(actualSales - rollingPlanQuotaFrozen);
  }

  if (measureName === 'Cumulative Unit Gap') {
    return rowArr[rIdx].measures[mIdx].quarters.reduce((qInit, quarter) => {
      qInit += Math.round(lastNonZeroValue(quarter.weeks));
      return qInit;
    }, 0);
  }

  /*REVENUE*/
  if (measureName === 'Plan ASP $') {
    const planSalesIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

    const rowUnitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const planQuotaIdx = rowArr[rowUnitIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota U');

    if (planSalesIdx === -1 || planQuotaIdx === -1) {
      return 0;
    }

    const planQuotaUnit = calculateActualMeasureTotal(rowArr[rowUnitIdx].measures[planQuotaIdx].quarters);
    const planQuotaValue = calculateActualMeasureTotal(rowArr[rIdx].measures[planSalesIdx].quarters);

    return planQuotaUnit !== 0 ? Math.round(planQuotaValue / planQuotaUnit) : 0;
  }

  if (measureName === 'ASP Actual $') {
    const actualSalesIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Actual Sales $');
    const rowUnitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const actualSalesUnitIdx = rowArr[rowUnitIdx].measures
      .findIndex((measure) => measure.name === 'Actual Sales U');

    if (actualSalesIdx === -1 || actualSalesUnitIdx === -1) {
      return 0;
    }

    const actualSales = calculateActualMeasureTotal(rowArr[rIdx].measures[actualSalesIdx].quarters);
    const actualSalesUnit = calculateActualMeasureTotal(rowArr[rowUnitIdx].measures[actualSalesUnitIdx].quarters);

    return actualSalesUnit !== 0 ? Math.round(actualSales / actualSalesUnit) : 0;
  }

  if (measureName === 'PL vs AC ASP $') {
    /*ASP Actual $ Calculation*/
    const aspActualIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'ASP Actual $');
    const quarterLength = rowArr[rIdx].measures[aspActualIdx].quarters.length;
    const measureTotal = calculateActualMeasureTotal(rowArr[rIdx].measures[aspActualIdx].quarters);
    const aspActual = quarterLength !== 0 ? Math.round(measureTotal / quarterLength) : 0;

    /*Rolling Plan ASP Frozen $ value*/
    const rollingPlanAspFrozenIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Rolling Plan ASP Frozen $');

    if (rollingPlanAspFrozenIdx === -1) {
      return 0;
    }

    const rollingPlanAspFrozen = calculateActualMeasureTotal(rowArr[rIdx].measures[rollingPlanAspFrozenIdx].quarters);

    return Math.round(aspActual - rollingPlanAspFrozen);
  }

  if (measureName === 'Fcst Unconst vs LY $') {
    const forecastUnconstrainedIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Forecast Unconstrained $');
    const lyActualsIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'LY - Actuals $');

    if (forecastUnconstrainedIdx === -1 || lyActualsIdx === -1) {
      return 0;
    }

    const forecastUnconstrained = calculateActualMeasureTotal(rowArr[rIdx].measures[forecastUnconstrainedIdx].quarters);
    const lyActuals = calculateActualMeasureTotal(rowArr[rIdx].measures[lyActualsIdx].quarters);

    return Math.round(forecastUnconstrained - lyActuals);
  }

  if (measureName === 'Plan vs Fcst Uncons $') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');
    const forecastUnconstrainedIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Forecast Unconstrained $');

    if (planQuotaIdx === -1 || forecastUnconstrainedIdx === -1) {
      return 0;
    }

    const planQuota = calculateActualMeasureTotal(rowArr[rIdx].measures[planQuotaIdx].quarters);
    const forecastUnconstrained = calculateActualMeasureTotal(rowArr[rIdx].measures[forecastUnconstrainedIdx].quarters);

    return Math.round(planQuota - forecastUnconstrained);
  }

  if (measureName === 'PL vs LY $ %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');
    const lyActualsIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LY - Actuals $');

    if (planQuotaIdx === -1 || lyActualsIdx === -1) {
      return 0;
    }

    const planQuota = calculateActualMeasureTotal(rowArr[rIdx].measures[planQuotaIdx].quarters);
    const lyActuals = calculateActualMeasureTotal(rowArr[rIdx].measures[lyActualsIdx].quarters);

    return lyActuals !== 0 ? OneDecimalPlace(((planQuota - lyActuals) / lyActuals) * 100) : 0;
  }

  if (measureName === 'PL vs LQ $ %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');
    const lqActualsIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LQ - Actuals $');

    if (planQuotaIdx === -1 || lqActualsIdx === -1) {
      return 0;
    }

    const planQuota = calculateActualMeasureTotal(rowArr[rIdx].measures[planQuotaIdx].quarters);
    const lqActuals = calculateActualMeasureTotal(rowArr[rIdx].measures[lqActualsIdx].quarters);

    return lqActuals !== 0 ? OneDecimalPlace(((planQuota - lqActuals) / lqActuals) * 100) : 0;
  }

  if (measureName === 'PL vs AC $') {
    const actualSalesIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Actual Sales $');
    const rollingPlanQuotaFrozenIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Rolling Plan / Quota Frozen Sales $');

    if (actualSalesIdx === -1 || rollingPlanQuotaFrozenIdx === -1) {
      return 0;
    }

    const actualSales = calculateActualMeasureTotal(rowArr[rIdx].measures[actualSalesIdx].quarters);
    const rollingPlanQuotaFrozen = calculateActualMeasureTotal(rowArr[rIdx].measures[rollingPlanQuotaFrozenIdx].quarters);

    return Math.round(actualSales - rollingPlanQuotaFrozen);
  }

  if (measureName === 'Plan ASP Frozen $') {
    const salesPlanFrozenIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Sales Plan Frozen $');
    const rowUnitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const planFrozenIdx = rowArr[rowUnitIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota U Frozen');

    if (salesPlanFrozenIdx === -1 || planFrozenIdx === -1) {
      return 0;
    }

    const salesPlanFrozen = calculateActualMeasureTotal(rowArr[rIdx].measures[salesPlanFrozenIdx].quarters);
    const planFrozen = calculateActualMeasureTotal(rowArr[rowUnitIdx].measures[planFrozenIdx].quarters, true);

    return planFrozen !== 0 ? Math.round(salesPlanFrozen / planFrozen) : 0;
  }

  if (measureName === 'Rolling Plan ASP Frozen $') {
    const rollingPlanFrozenIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Rolling Plan / Quota Frozen Sales $');
    const rowUnitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const rollingPlanQuotaFrozenIdx = rowArr[rowUnitIdx].measures
      .findIndex((measure) => measure.name === 'Rolling Plan / Quota Frozen U');

    if (rollingPlanFrozenIdx === -1 || rollingPlanQuotaFrozenIdx === -1) {
      return 0;
    }

    const rollingPlanFrozen = calculateActualMeasureTotal(rowArr[rIdx].measures[rollingPlanFrozenIdx].quarters);
    const rollingPlanQuotaFrozen =
      calculateActualMeasureTotal(rowArr[rowUnitIdx].measures[rollingPlanQuotaFrozenIdx].quarters, true);

    return rollingPlanQuotaFrozen !== 0 ? Math.round(rollingPlanFrozen / rollingPlanQuotaFrozen) : 0;
  }

  if (measureName === 'Plan ASP Prev Fcst $') {
    const planPrevFcstIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Prev Fcst $');
    const rowUnitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const planPrevFcstUnitIdx = rowArr[rowUnitIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Prev Fcst U');

    if (planPrevFcstIdx === -1 || planPrevFcstUnitIdx === -1) {
      return 0;
    }

    const planPrevFcst = calculateActualMeasureTotal(rowArr[rIdx].measures[planPrevFcstIdx].quarters);
    const planPrevFcstUnit =
      calculateActualMeasureTotal(rowArr[rowUnitIdx].measures[planPrevFcstUnitIdx].quarters, true);

    return planPrevFcstUnit !== 0 ? Math.round(planPrevFcst / planPrevFcstUnit) : 0;
  }

  /*MARGIN*/
  if (measureName === 'Actual Margin %') {
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Margin $');

    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const actualSalesIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'Actual Sales $');

    if (marginIdx === -1 || actualSalesIdx === -1) {
      return 0;
    }

    const actualMargin = calculateActualMeasureTotal(rowArr[rIdx].measures[marginIdx].quarters);
    const actualSales = calculateActualMeasureTotal(rowArr[rowRevenueIdx].measures[actualSalesIdx].quarters);

    return actualSales !== 0 ? OneDecimalPlace((actualMargin / actualSales) * 100) : 0;
  }

  if (measureName === 'Margin %') {
    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Margin $');
    const planQuotaSalesIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

    if (marginIdx === -1 || planQuotaSalesIdx === -1) {
      return 0;
    }

    const margin = calculateActualMeasureTotal(rowArr[rIdx].measures[marginIdx].quarters);
    const planQuotaSales = calculateActualMeasureTotal(rowArr[rowRevenueIdx].measures[planQuotaSalesIdx].quarters);

    return planQuotaSales !== 0 ? OneDecimalPlace((margin / planQuotaSales) * 100) : 0;
  }

  if (measureName === 'Plan Margin Frozen %') {
    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const planMarginFrozenIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Plan Margin Frozen $');
    const salesPlanFrozenIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'Sales Plan Frozen $');

    if (planMarginFrozenIdx === -1 || salesPlanFrozenIdx === -1) {
      return 0;
    }

    const planMarginFrozen = calculateActualMeasureTotal(rowArr[rIdx].measures[planMarginFrozenIdx].quarters);
    const salesPlanFrozen = calculateActualMeasureTotal(rowArr[rowRevenueIdx].measures[salesPlanFrozenIdx].quarters);

    return salesPlanFrozen !== 0 ? OneDecimalPlace((planMarginFrozen / salesPlanFrozen) * 100) : 0;
  }

  if (measureName === 'Rolling Margin Frozen %') {
    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const rollingMarginFrozenIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Rolling Margin Frozen $');
    const rollingPlanFrozenIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'Rolling Plan / Quota Frozen Sales $');

    if (rollingMarginFrozenIdx === -1 || rollingPlanFrozenIdx === -1) {
      return 0;
    }

    const rollingMarginFrozen = calculateActualMeasureTotal(rowArr[rIdx].measures[rollingMarginFrozenIdx].quarters);
    const rollingPlanFrozen = calculateActualMeasureTotal(rowArr[rowRevenueIdx].measures[rollingPlanFrozenIdx].quarters);

    return rollingPlanFrozen !== 0 ? OneDecimalPlace((rollingMarginFrozen / rollingPlanFrozen) * 100) : 0;
  }

  if (measureName === 'LY Margin %') {
    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const lyMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'LY Margin $');
    const lyActualsIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'LY - Actuals $');

    if (lyMarginIdx === -1 || lyActualsIdx === -1) {
      return 0;
    }

    const lyMargin = calculateActualMeasureTotal(rowArr[rIdx].measures[lyMarginIdx].quarters);
    const lyActuals = calculateActualMeasureTotal(rowArr[rowRevenueIdx].measures[lyActualsIdx].quarters);

    return lyActuals !== 0 ? OneDecimalPlace((lyMargin / lyActuals) * 100) : 0;
  }

  if (measureName === 'LQ Margin %') {
    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const lqMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'LQ Margin $');
    const lqActualsIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'LQ - Actuals $');

    if (lqMarginIdx === -1 || lqActualsIdx === -1) {
      return 0;
    }

    const lqMargin = calculateActualMeasureTotal(rowArr[rIdx].measures[lqMarginIdx].quarters);
    const lqActuals = calculateActualMeasureTotal(rowArr[rowRevenueIdx].measures[lqActualsIdx].quarters);

    return lqActuals !== 0 ? OneDecimalPlace((lqMargin / lqActuals) * 100) : 0;
  }

  if (measureName === 'PL vs LY Margin %') {
    /*Margin %*/
    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Margin $');
    const planQuotaSalesIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

    if (marginIdx === -1 || planQuotaSalesIdx === -1) {
      return 0;
    }

    const margin = calculateActualMeasureTotal(rowArr[rIdx].measures[marginIdx].quarters);
    const planQuotaSales = calculateActualMeasureTotal(rowArr[rowRevenueIdx].measures[planQuotaSalesIdx].quarters);

    const marginPct = planQuotaSales !== 0 ? OneDecimalPlace((margin / planQuotaSales) * 100) : 0;

    /*LY Margin %*/
    const lyMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'LY Margin $');
    const lyActualsIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'LY - Actuals $');

    if (lyMarginIdx === -1 || lyActualsIdx === -1) {
      return 0;
    }

    const lyMargin = calculateActualMeasureTotal(rowArr[rIdx].measures[lyMarginIdx].quarters);
    const lyActuals = calculateActualMeasureTotal(rowArr[rowRevenueIdx].measures[lyActualsIdx].quarters);

    const lyMarginPct = lyActuals !== 0 ? Math.round((lyMargin / lyActuals) * 100) : 0;

    return OneDecimalPlace(marginPct - lyMarginPct);
  }

  if (measureName === 'PL vs LQ Margin %') {
    /*Margin %*/
    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Margin $');
    const planQuotaSalesIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

    if (marginIdx === -1 || planQuotaSalesIdx === -1) {
      return 0;
    }

    const margin = calculateActualMeasureTotal(rowArr[rIdx].measures[marginIdx].quarters);
    const planQuotaSales = calculateActualMeasureTotal(rowArr[rowRevenueIdx].measures[planQuotaSalesIdx].quarters);

    const marginPct = planQuotaSales !== 0 ? Math.round((margin / planQuotaSales) * 100) : 0;

    /*LQ Margin %*/
    const lqMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'LQ Margin $');
    const lqActualsIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'LQ - Actuals $');

    if (lqMarginIdx === -1 || lqActualsIdx === -1) {
      return 0;
    }

    const lqMargin = calculateActualMeasureTotal(rowArr[rIdx].measures[lqMarginIdx].quarters);
    const lqActuals = calculateActualMeasureTotal(rowArr[rowRevenueIdx].measures[lqActualsIdx].quarters);

    const lqMarginPct = lqActuals !== 0 ? Math.round((lqMargin / lqActuals) * 100) : 0;

    return OneDecimalPlace(marginPct - lqMarginPct);
  }

  if (measureName === 'PL vs AC Margin %') {
    /*Margin %*/
    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Margin $');
    const planQuotaSalesIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

    if (marginIdx === -1 || planQuotaSalesIdx === -1) {
      return 0;
    }

    const margin = calculateActualMeasureTotal(rowArr[rIdx].measures[marginIdx].quarters);
    const planQuotaSales = calculateActualMeasureTotal(rowArr[rowRevenueIdx].measures[planQuotaSalesIdx].quarters);

    const marginPct = planQuotaSales !== 0 ? Math.round((margin / planQuotaSales) * 100) : 0;

    /*Actual Margin %*/
    const actualMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Actual Margin $');
    const actualSalesIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'Actual Sales $');

    if (actualMarginIdx === -1 || actualSalesIdx === -1) {
      return 0;
    }

    const actualMargin = calculateActualMeasureTotal(rowArr[rIdx].measures[actualMarginIdx].quarters);
    const actualSales = calculateActualMeasureTotal(rowArr[rowRevenueIdx].measures[actualSalesIdx].quarters);

    const actualMarginPct = actualSales !== 0 ? Math.round((actualMargin / actualSales) * 100) : 0;
    return OneDecimalPlace(marginPct - actualMarginPct);
  }

  if (measureName === 'PL vs AC Margin $') {
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Margin $');
    const actualMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Actual Margin $');

    if (marginIdx === -1 || actualMarginIdx === -1) {
      return 0;
    }

    const margin = calculateActualMeasureTotal(rowArr[rIdx].measures[marginIdx].quarters);
    const actualMargin = calculateActualMeasureTotal(rowArr[rIdx].measures[actualMarginIdx].quarters);

    return Math.round(margin - actualMargin);
  }

  return calculateActualMeasureTotal(rowArr[rIdx].measures[mIdx].quarters);
};

export const calculateActualMeasureTotal = (quarterArr, isRounded = false): number => {
  const total = quarterArr.reduce((qInit, quarter) => {
    qInit += quarter.weeks.reduce((wInit, week) => {
      wInit += week.value;
      return wInit;
    }, 0);
    return qInit;
  }, 0);

  return isRounded ? Math.round(total) : Math.round(total);
};

export const calculateQuarterTotal = (
  rowArr,
  rIdx: number,
  mIdx: number,
  qIdx: number,
  measureGroup: string,
  measureName: string,
): number => {
  /*UNITS*/
  if (measureName === 'Fcst Unconst vs LY U') {
    const forecastUnconstrainedIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Forecast Unconstrained U');
    const lyActualsIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'LY - Actuals U');

    if (forecastUnconstrainedIdx === -1 || lyActualsIdx === -1) {
      return 0;
    }

    const forecastUnconstrained = calculateActualQuarterTotal(rowArr[rIdx].measures[forecastUnconstrainedIdx].quarters[qIdx].weeks, true);
    const lyActuals = calculateActualQuarterTotal(rowArr[rIdx].measures[lyActualsIdx].quarters[qIdx].weeks, true);

    return Math.round(forecastUnconstrained - lyActuals);
  }

  if (measureName === 'Plan vs Fcst Uncons U') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota U');
    const forecastUnconstrainedIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Forecast Unconstrained U');

    if (planQuotaIdx === -1 || forecastUnconstrainedIdx === -1) {
      return 0;
    }

    const planQuota = calculateActualQuarterTotal(rowArr[rIdx].measures[planQuotaIdx].quarters[qIdx].weeks, true);
    const forecastUnconstrained = calculateActualQuarterTotal(rowArr[rIdx].measures[forecastUnconstrainedIdx].quarters[qIdx].weeks, true);

    return Math.round(planQuota - forecastUnconstrained);
  }

  if (measureName === 'PL vs LY U %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota U');
    const lyActualsIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'LY - Actuals U');

    if (planQuotaIdx === -1 || lyActualsIdx === -1) {
      return 0;
    }

    const planQuota = calculateActualQuarterTotal(rowArr[rIdx].measures[planQuotaIdx].quarters[qIdx].weeks, true);
    const lyActuals = calculateActualQuarterTotal(rowArr[rIdx].measures[lyActualsIdx].quarters[qIdx].weeks, true);

    return lyActuals !== 0 ? OneDecimalPlace(((planQuota - lyActuals) / lyActuals) * 100) : 0;
  }

  if (measureName === 'PL vs LQ U %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota U');
    const lqActualsIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'LQ - Actuals U');

    if (planQuotaIdx === -1 || lqActualsIdx === -1) {
      return 0;
    }

    const planQuota = calculateActualQuarterTotal(rowArr[rIdx].measures[planQuotaIdx].quarters[qIdx].weeks, true);
    const lqActuals = calculateActualQuarterTotal(rowArr[rIdx].measures[lqActualsIdx].quarters[qIdx].weeks, true);

    return lqActuals !== 0 ? OneDecimalPlace(((planQuota - lqActuals) / lqActuals) * 100) : 0;
  }

  if (measureName === 'PL vs AC U') {
    const actualSalesIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Actual Sales U');
    const rollingPlanQuotaFrozenIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Rolling Plan / Quota Frozen U');

    if (actualSalesIdx === -1 || rollingPlanQuotaFrozenIdx === -1) {
      return 0;
    }

    const actualSales =
      calculateActualQuarterTotal(rowArr[rIdx].measures[actualSalesIdx].quarters[qIdx].weeks, true);
    const rollingPlanQuotaFrozen =
      calculateActualQuarterTotal(rowArr[rIdx].measures[rollingPlanQuotaFrozenIdx].quarters[qIdx].weeks, true);

    return Math.round(actualSales - rollingPlanQuotaFrozen);
  }

  if (measureName === 'Cumulative Unit Gap') {
    return Math.round(lastNonZeroValue(rowArr[rIdx].measures[mIdx].quarters[qIdx].weeks));
  }

  /*REVENUE*/
  if (measureName === 'Plan ASP $') {
    const planSalesIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

    const rowUnitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const planQuotaIdx = rowArr[rowUnitIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota U');

    if (planSalesIdx === -1 || planQuotaIdx === -1) {
      return 0;
    }

    const planQuotaUnit = calculateActualQuarterTotal(rowArr[rowUnitIdx].measures[planQuotaIdx].quarters[qIdx].weeks);
    const planQuotaValue = calculateActualQuarterTotal(rowArr[rIdx].measures[planSalesIdx].quarters[qIdx].weeks);

    return planQuotaUnit !== 0 ? Math.round(planQuotaValue / planQuotaUnit) : 0;
  }

  if (measureName === 'ASP Actual $') {
    const actualSalesIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Actual Sales $');
    const rowUnitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const actualSalesUnitIdx = rowArr[rowUnitIdx].measures
      .findIndex((measure) => measure.name === 'Actual Sales U');

    if (actualSalesIdx === -1 || actualSalesUnitIdx === -1) {
      return 0;
    }

    const actualSales = calculateActualQuarterTotal(rowArr[rIdx].measures[actualSalesIdx].quarters[qIdx].weeks);
    const actualSalesUnit = calculateActualQuarterTotal(rowArr[rowUnitIdx].measures[actualSalesUnitIdx].quarters[qIdx].weeks);

    return actualSalesUnit !== 0 ? Math.round(actualSales / actualSalesUnit) : 0;
  }

  if (measureName === 'Rolling Plan AF ASP') {
    const actualSalesIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Actual Sales $');
    const rollingPlanAspIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Rolling Plan ASP Frozen $');
    const rowUnitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const actualSalesUnitIdx = rowArr[rowUnitIdx].measures
      .findIndex((measure) => measure.name === 'Actual Sales U');

    if (actualSalesIdx === -1 || actualSalesUnitIdx === -1 || rollingPlanAspIdx === -1) {
      return 0;
    }

    const actualSales = calculateActualMeasureTotal(rowArr[rIdx].measures[actualSalesIdx].quarters);
    const rollingPlanAsp = calculateActualMeasureTotal(rowArr[rIdx].measures[rollingPlanAspIdx].quarters);
    const actualSalesUnit = calculateActualMeasureTotal(rowArr[rowUnitIdx].measures[actualSalesUnitIdx].quarters);

    return rowArr[rIdx].measures[actualSalesIdx].quarters[qIdx].isPast
      ? (actualSalesUnit !== 0 ? Math.round(actualSales / actualSalesUnit) : 0)
      : Math.round(rollingPlanAsp);
  }

  if (measureName === 'PL vs AC ASP $') {
    /*ASP Actual $ Calculation*/
    const aspActualIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'ASP Actual $');
    const quarterLength = rowArr[rIdx].measures[aspActualIdx].quarters.length;
    const measureTotal = calculateActualQuarterTotal(rowArr[rIdx].measures[aspActualIdx].quarters[qIdx].weeks);
    const aspActual = quarterLength !== 0 ? Math.round(measureTotal / quarterLength) : 0;

    /*Rolling Plan ASP Frozen $ value*/
    const rollingPlanAspFrozenIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Rolling Plan ASP Frozen $');

    if (rollingPlanAspFrozenIdx === -1) {
      return 0;
    }

    const rollingPlanAspFrozen =
      calculateActualQuarterTotal(rowArr[rIdx].measures[rollingPlanAspFrozenIdx].quarters[qIdx].weeks);

    return Math.round(aspActual - rollingPlanAspFrozen);
  }

  if (measureName === 'Fcst Unconst vs LY $') {
    const forecastUnconstrainedIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Forecast Unconstrained $');
    const lyActualsIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'LY - Actuals $');

    if (forecastUnconstrainedIdx === -1 || lyActualsIdx === -1) {
      return 0;
    }

    const forecastUnconstrained = calculateActualQuarterTotal(rowArr[rIdx].measures[forecastUnconstrainedIdx].quarters[qIdx].weeks);
    const lyActuals = calculateActualQuarterTotal(rowArr[rIdx].measures[lyActualsIdx].quarters[qIdx].weeks);

    return Math.round(forecastUnconstrained - lyActuals);
  }

  if (measureName === 'Plan vs Fcst Uncons $') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');
    const forecastUnconstrainedIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Forecast Unconstrained $');

    if (planQuotaIdx === -1 || forecastUnconstrainedIdx === -1) {
      return 0;
    }

    const planQuota = calculateActualQuarterTotal(rowArr[rIdx].measures[planQuotaIdx].quarters[qIdx].weeks);
    const forecastUnconstrained = calculateActualQuarterTotal(rowArr[rIdx].measures[forecastUnconstrainedIdx].quarters[qIdx].weeks);

    return Math.round(planQuota - forecastUnconstrained);
  }

  if (measureName === 'PL vs LY $ %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');
    const lyActualsIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LY - Actuals $');

    if (planQuotaIdx === -1 || lyActualsIdx === -1) {
      return 0;
    }

    const planQuota = calculateActualQuarterTotal(rowArr[rIdx].measures[planQuotaIdx].quarters[qIdx].weeks);
    const lyActuals = calculateActualQuarterTotal(rowArr[rIdx].measures[lyActualsIdx].quarters[qIdx].weeks);

    return lyActuals !== 0 ? OneDecimalPlace(((planQuota - lyActuals) / lyActuals) * 100) : 0;
  }

  if (measureName === 'PL vs LQ $ %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');
    const lqActualsIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LQ - Actuals $');

    if (planQuotaIdx === -1 || lqActualsIdx === -1) {
      return 0;
    }

    const planQuota = calculateActualQuarterTotal(rowArr[rIdx].measures[planQuotaIdx].quarters[qIdx].weeks);
    const lqActuals = calculateActualQuarterTotal(rowArr[rIdx].measures[lqActualsIdx].quarters[qIdx].weeks);

    return lqActuals !== 0 ? OneDecimalPlace(((planQuota - lqActuals) / lqActuals) * 100) : 0;
  }

  if (measureName === 'PL vs AC $') {
    const actualSalesIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Actual Sales $');
    const rollingPlanQuotaFrozenIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Rolling Plan / Quota Frozen Sales $');

    if (actualSalesIdx === -1 || rollingPlanQuotaFrozenIdx === -1) {
      return 0;
    }

    const actualSales = calculateActualQuarterTotal(rowArr[rIdx].measures[actualSalesIdx].quarters[qIdx].weeks);
    const rollingPlanQuotaFrozen =
      calculateActualQuarterTotal(rowArr[rIdx].measures[rollingPlanQuotaFrozenIdx].quarters[qIdx].weeks);

    return Math.round(actualSales - rollingPlanQuotaFrozen);
  }

  if (measureName === 'Plan ASP Frozen $') {
    const salesPlanFrozenIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Sales Plan Frozen $');
    const rowUnitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const planFrozenIdx = rowArr[rowUnitIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota U Frozen');

    if (salesPlanFrozenIdx === -1 || planFrozenIdx === -1) {
      return 0;
    }

    const salesPlanFrozen = calculateActualQuarterTotal(rowArr[rIdx].measures[salesPlanFrozenIdx].quarters[qIdx].weeks);
    const planFrozen =
      calculateActualQuarterTotal(rowArr[rowUnitIdx].measures[planFrozenIdx].quarters[qIdx].weeks, true);

    return planFrozen !== 0 ? Math.round(salesPlanFrozen / planFrozen) : 0;
  }

  if (measureName === 'Rolling Plan ASP Frozen $') {
    const rollingPlanFrozenIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Rolling Plan / Quota Frozen Sales $');
    const rowUnitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const rollingPlanQuotaFrozenIdx = rowArr[rowUnitIdx].measures
      .findIndex((measure) => measure.name === 'Rolling Plan / Quota Frozen U');

    if (rollingPlanFrozenIdx === -1 || rollingPlanQuotaFrozenIdx === -1) {
      return 0;
    }

    const rollingPlanFrozen = calculateActualQuarterTotal(rowArr[rIdx].measures[rollingPlanFrozenIdx].quarters[qIdx].weeks);
    const rollingPlanQuotaFrozen =
      calculateActualQuarterTotal(rowArr[rowUnitIdx].measures[rollingPlanQuotaFrozenIdx].quarters[qIdx].weeks, true);

    return rollingPlanQuotaFrozen !== 0 ? Math.round(rollingPlanFrozen / rollingPlanQuotaFrozen) : 0;
  }

  if (measureName === 'Plan ASP Prev Fcst $') {
    const planPrevFcstIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Prev Fcst $');
    const rowUnitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const planPrevFcstUnitIdx = rowArr[rowUnitIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Prev Fcst U');

    if (planPrevFcstIdx === -1 || planPrevFcstUnitIdx === -1) {
      return 0;
    }

    const planPrevFcst = calculateActualQuarterTotal(rowArr[rIdx].measures[planPrevFcstIdx].quarters[qIdx].weeks);
    const planPrevFcstUnit =
      calculateActualQuarterTotal(rowArr[rowUnitIdx].measures[planPrevFcstUnitIdx].quarters[qIdx].weeks, true);

    return planPrevFcstUnit !== 0 ? Math.round(planPrevFcst / planPrevFcstUnit) : 0;
  }

  /*MARGIN*/
  if (measureName === 'Margin %') {
    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Margin $');
    const planQuotaSalesIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

    if (marginIdx === -1 || planQuotaSalesIdx === -1) {
      return 0;
    }

    const margin = calculateActualQuarterTotal(rowArr[rIdx].measures[marginIdx].quarters[qIdx].weeks);
    const planQuotaSales = calculateActualQuarterTotal(rowArr[rowRevenueIdx].measures[planQuotaSalesIdx].quarters[qIdx].weeks);

    return planQuotaSales !== 0 ? OneDecimalPlace((margin / planQuotaSales) * 100) : 0;
  }

  if (measureName === 'Plan Margin Frozen %') {
    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const planMarginFrozenIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Plan Margin Frozen $');
    const salesPlanFrozenIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'Sales Plan Frozen $');

    if (planMarginFrozenIdx === -1 || salesPlanFrozenIdx === -1) {
      return 0;
    }

    const planMarginFrozen = calculateActualQuarterTotal(rowArr[rIdx].measures[planMarginFrozenIdx].quarters[qIdx].weeks);
    const salesPlanFrozen = calculateActualQuarterTotal(rowArr[rowRevenueIdx].measures[salesPlanFrozenIdx].quarters[qIdx].weeks);

    return salesPlanFrozen !== 0 ? OneDecimalPlace((planMarginFrozen / salesPlanFrozen) * 100) : 0;
  }

  if (measureName === 'Rolling Margin Frozen %') {
    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const rollingMarginFrozenIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Rolling Margin Frozen $');
    const rollingPlanFrozenIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'Rolling Plan / Quota Frozen Sales $');

    if (rollingMarginFrozenIdx === -1 || rollingPlanFrozenIdx === -1) {
      return 0;
    }

    const rollingMarginFrozen = calculateActualQuarterTotal(rowArr[rIdx].measures[rollingMarginFrozenIdx].quarters[qIdx].weeks);
    const rollingPlanFrozen = calculateActualQuarterTotal(rowArr[rowRevenueIdx].measures[rollingPlanFrozenIdx].quarters[qIdx].weeks);

    return rollingPlanFrozen !== 0 ? OneDecimalPlace((rollingMarginFrozen / rollingPlanFrozen) * 100) : 0;
  }

  if (measureName === 'LY Margin %') {
    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const lyMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'LY Margin $');
    const lyActualsIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'LY - Actuals $');

    if (lyMarginIdx === -1 || lyActualsIdx === -1) {
      return 0;
    }

    const lyMargin = calculateActualQuarterTotal(rowArr[rIdx].measures[lyMarginIdx].quarters[qIdx].weeks);
    const lyActuals = calculateActualQuarterTotal(rowArr[rowRevenueIdx].measures[lyActualsIdx].quarters[qIdx].weeks);

    return lyActuals !== 0 ? OneDecimalPlace((lyMargin / lyActuals) * 100) : 0;
  }

  if (measureName === 'LQ Margin %') {
    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const lqMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'LQ Margin $');
    const lqActualsIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'LQ - Actuals $');

    if (lqMarginIdx === -1 || lqActualsIdx === -1) {
      return 0;
    }

    const lqMargin = calculateActualQuarterTotal(rowArr[rIdx].measures[lqMarginIdx].quarters[qIdx].weeks);
    const lqActuals = calculateActualQuarterTotal(rowArr[rowRevenueIdx].measures[lqActualsIdx].quarters[qIdx].weeks);

    return lqActuals !== 0 ? OneDecimalPlace((lqMargin / lqActuals) * 100) : 0;
  }

  if (measureName === 'PL vs LY Margin %') {
    /*Margin %*/
    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Margin $');
    const planQuotaSalesIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

    if (marginIdx === -1 || planQuotaSalesIdx === -1) {
      return 0;
    }

    const margin = calculateActualQuarterTotal(rowArr[rIdx].measures[marginIdx].quarters[qIdx].weeks);
    const planQuotaSales = calculateActualQuarterTotal(rowArr[rowRevenueIdx].measures[planQuotaSalesIdx].quarters[qIdx].weeks);

    const marginPct = planQuotaSales !== 0 ? Math.round((margin / planQuotaSales) * 100) : 0;

    /*LY Margin %*/
    const lyMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'LY Margin $');
    const lyActualsIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'LY - Actuals $');

    if (lyMarginIdx === -1 || lyActualsIdx === -1) {
      return 0;
    }

    const lyMargin = calculateActualQuarterTotal(rowArr[rIdx].measures[lyMarginIdx].quarters[qIdx].weeks);
    const lyActuals = calculateActualQuarterTotal(rowArr[rowRevenueIdx].measures[lyActualsIdx].quarters[qIdx].weeks);

    const lyMarginPct = lyActuals !== 0 ? Math.round((lyMargin / lyActuals) * 100) : 0;

    return OneDecimalPlace(marginPct - lyMarginPct);
  }

  if (measureName === 'PL vs LQ Margin %') {
    /*Margin %*/
    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Margin $');
    const planQuotaSalesIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

    if (marginIdx === -1 || planQuotaSalesIdx === -1) {
      return 0;
    }

    const margin = calculateActualQuarterTotal(rowArr[rIdx].measures[marginIdx].quarters[qIdx].weeks);
    const planQuotaSales = calculateActualQuarterTotal(rowArr[rowRevenueIdx].measures[planQuotaSalesIdx].quarters[qIdx].weeks);

    const marginPct = planQuotaSales !== 0 ? Math.round((margin / planQuotaSales) * 100) : 0;

    /*LQ Margin %*/
    const lqMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'LQ Margin $');
    const lqActualsIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'LQ - Actuals $');

    if (lqMarginIdx === -1 || lqActualsIdx === -1) {
      return 0;
    }

    const lqMargin = calculateActualQuarterTotal(rowArr[rIdx].measures[lqMarginIdx].quarters[qIdx].weeks);
    const lqActuals = calculateActualQuarterTotal(rowArr[rowRevenueIdx].measures[lqActualsIdx].quarters[qIdx].weeks);

    const lqMarginPct = lqActuals !== 0 ? Math.round((lqMargin / lqActuals) * 100) : 0;

    return OneDecimalPlace(marginPct - lqMarginPct);
  }

  if (measureName === 'PL vs AC Margin %') {
    /*Margin %*/
    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Margin $');
    const planQuotaSalesIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

    if (marginIdx === -1 || planQuotaSalesIdx === -1) {
      return 0;
    }

    const margin = calculateActualQuarterTotal(rowArr[rIdx].measures[marginIdx].quarters[qIdx].weeks);
    const planQuotaSales = calculateActualQuarterTotal(rowArr[rowRevenueIdx].measures[planQuotaSalesIdx].quarters[qIdx].weeks);

    const marginPct = planQuotaSales !== 0 ? Math.round((margin / planQuotaSales) * 100) : 0;

    /*Actual Margin %*/
    const actualMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Actual Margin $');
    const actualSalesIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'Actual Sales $');

    if (actualMarginIdx === -1 || actualSalesIdx === -1) {
      return 0;
    }

    const actualMargin = calculateActualQuarterTotal(rowArr[rIdx].measures[actualMarginIdx].quarters[qIdx].weeks);
    const actualSales = calculateActualQuarterTotal(rowArr[rowRevenueIdx].measures[actualSalesIdx].quarters[qIdx].weeks);

    const actualMarginPct = actualSales !== 0 ? Math.round((actualMargin / actualSales) * 100) : 0;
    return OneDecimalPlace(marginPct - actualMarginPct);
  }

  if (measureName === 'PL vs AC Margin $') {
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Margin $');
    const actualMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Actual Margin $');

    if (marginIdx === -1 || actualMarginIdx === -1) {
      return 0;
    }

    const margin = calculateActualQuarterTotal(rowArr[rIdx].measures[marginIdx].quarters[qIdx].weeks);
    const actualMargin = calculateActualQuarterTotal(rowArr[rIdx].measures[actualMarginIdx].quarters[qIdx].weeks);

    return Math.round(margin - actualMargin);
  }

  if (measureName === 'Actual Margin $') {
    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');

    const actualSalesIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Actual Sales $');
    const cogsIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'COGS $');

    if (actualSalesIdx === -1 || cogsIdx === -1) {
      return 0;
    }

    const actualSales = calculateActualQuarterTotal(rowArr[rowRevenueIdx].measures[actualSalesIdx].quarters[qIdx].weeks);
    const cogsValue = calculateActualQuarterTotal(rowArr[rIdx].measures[cogsIdx].quarters[qIdx].weeks);

    return Math.round(actualSales - cogsValue);
  }

  if (measureName === 'Actual Margin %') {
    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');

    const actualSalesIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Actual Sales $');
    const cogsIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'COGS $');

    if (actualSalesIdx === -1 || cogsIdx === -1) {
      return 0;
    }

    const actualSales = calculateActualQuarterTotal(rowArr[rowRevenueIdx].measures[actualSalesIdx].quarters[qIdx].weeks);
    const cogsValue = calculateActualQuarterTotal(rowArr[rIdx].measures[cogsIdx].quarters[qIdx].weeks);
    const actualMargin = Math.round(actualSales - cogsValue);

    return actualSales !== 0 ? OneDecimalPlace((actualMargin / actualSales) * 100) : 0;
  }

  return calculateActualQuarterTotal(
    rowArr[rIdx].measures[mIdx].quarters[qIdx].weeks,
    rowArr[rIdx].measures[mIdx].datatype === 'number'
  );
};

export const weekValue = (
  rowArr,
  rIdx: number,
  mIdx: number,
  qIdx: number,
  wIdx: number,
  week,
  measureGroup: string,
  measureName: string,
  datatype: string,
): number => {
  /*REVENUE*/
  if (measureName === 'Plan ASP $') {
    const planSalesIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

    const rowUnitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const planQuotaIdx = rowArr[rowUnitIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota U');

    if (planSalesIdx === -1 || planQuotaIdx === -1) {
      return 0;
    }

    const planQuotaUnit = rowArr[rowUnitIdx].measures[planQuotaIdx].quarters[qIdx].weeks[wIdx].value;
    const planQuotaValue = rowArr[rIdx].measures[planSalesIdx].quarters[qIdx].weeks[wIdx].value;

    return planQuotaUnit !== 0 ? Math.round(planQuotaValue / planQuotaUnit) : 0;
  }

  if (measureName === 'ASP Actual $') {
    const actualSalesIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Actual Sales $');
    const rowUnitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const actualSalesUnitIdx = rowArr[rowUnitIdx].measures
      .findIndex((measure) => measure.name === 'Actual Sales U');

    if (actualSalesIdx === -1 || actualSalesUnitIdx === -1) {
      return 0;
    }

    const actualSales = rowArr[rIdx].measures[actualSalesIdx].quarters[qIdx].weeks[wIdx].value;
    const actualSalesUnit = rowArr[rowUnitIdx].measures[actualSalesUnitIdx].quarters[qIdx].weeks[wIdx].value;

    return actualSalesUnit !== 0 ? Math.round(actualSales / actualSalesUnit) : 0;
  }

  if (measureName === 'Rolling Plan AF ASP') {
    const actualSalesIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Actual Sales $');
    const rollingPlanAspIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Rolling Plan ASP Frozen $');
    const rowUnitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const actualSalesUnitIdx = rowArr[rowUnitIdx].measures
      .findIndex((measure) => measure.name === 'Actual Sales U');

    if (actualSalesIdx === -1 || actualSalesUnitIdx === -1 || rollingPlanAspIdx === -1) {
      return 0;
    }

    const actualSales = rowArr[rIdx].measures[actualSalesIdx].quarters[qIdx].weeks[wIdx].value;
    const rollingPlanAsp = rowArr[rIdx].measures[rollingPlanAspIdx].quarters[qIdx].weeks[wIdx].value;
    const actualSalesUnit = rowArr[rowUnitIdx].measures[actualSalesUnitIdx].quarters[qIdx].weeks[wIdx].value;

    return rowArr[rIdx].measures[actualSalesIdx].quarters[qIdx].weeks[wIdx].isPast
      ? (actualSalesUnit !== 0 ? Math.round(actualSales / actualSalesUnit) : 0)
      : Math.round(rollingPlanAsp);
  }

  /*MARGIN*/
  if (measureName === 'Margin %') {
    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'Margin $');
    const planQuotaSalesIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

    if (marginIdx === -1 || planQuotaSalesIdx === -1) {
      return 0;
    }

    const margin = rowArr[rIdx].measures[marginIdx].quarters[qIdx].weeks[wIdx].value;
    const planQuotaSales = rowArr[rowRevenueIdx].measures[planQuotaSalesIdx].quarters[qIdx].weeks[wIdx].value;

    return planQuotaSales !== 0 ? OneDecimalPlace((margin / planQuotaSales) * 100) : 0;
  }

  if (measureName === 'Actual Margin $') {
    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');

    const actualSalesIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Actual Sales $');
    const cogsIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'COGS $');

    if (actualSalesIdx === -1 || cogsIdx === -1) {
      return 0;
    }

    const actualSales = rowArr[rowRevenueIdx].measures[actualSalesIdx].quarters[qIdx].weeks[wIdx].value;
    const cogsValue = rowArr[rIdx].measures[cogsIdx].quarters[qIdx].weeks[wIdx].value;

    return Math.round(actualSales - cogsValue);
  }

  if (measureName === 'Actual Margin %') {
    const rowRevenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');

    const actualSalesIdx = rowArr[rowRevenueIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Actual Sales $');
    const cogsIdx = rowArr[rIdx].measures
      .findIndex((measure) => measure.name === 'COGS $');

    if (actualSalesIdx === -1 || cogsIdx === -1) {
      return 0;
    }

    const actualSales = rowArr[rowRevenueIdx].measures[actualSalesIdx].quarters[qIdx].weeks[wIdx].value;
    const cogsValue = rowArr[rIdx].measures[cogsIdx].quarters[qIdx].weeks[wIdx].value;
    const actualMargin = Math.round(actualSales - cogsValue);

    return actualSales !== 0 ? OneDecimalPlace((actualMargin / actualSales) * 100) : 0;
  }

  return datatype === 'number' ? Math.round(week.value) : Math.round(week.value);
};

// @ts-ignore
export const calculateActualQuarterTotal = (weekArr, isRounded = false): number => {
  const total = weekArr.reduce((wInit, week) => {
    wInit += week.value;
    return wInit;
  }, 0);

  return isRounded ? Math.round(total) : Math.round(total);
};

export const lastNonZeroValue = (weekArr): number => {
  return weekArr
    .map((week) => week.value)
    .reverse()
    .filter((week) => week !== 0)[0] || 0;
};

export const checkIfAllQuartersArePast = (quarters): boolean => {
  return quarters.reduce((acc, value) => acc && value.isPast, true);
};
